<template>
  <v-card>
    <v-card-title class="sticky top-0">Aktivitetslogg</v-card-title>
    <v-divider />
    <div class="overflow-y-auto" :style="{ height: tableHeight }">
      <v-list two-line>
        <template v-for="(event, $i) in order(events)">
          <v-divider :key="$i" v-if="$i !== 0"></v-divider>
          <v-list-item :key="'i' + $i">
            <v-list-item-content>
              <v-list-item-title v-html="event.type" />
              <v-list-item-subtitle v-html="event.information" />
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text>{{
                event.created | dateFormat
              }}</v-list-item-action-text>

              <v-list-item-action-text>{{
                event.user
              }}</v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </div>
  </v-card>
</template>

<script>
import { format } from 'date-fns'
import orderBy from 'lodash.orderby'
import { tableHeight } from '@/mixins/tableHeight'

export default {
  name: 'LostPropertiesEvents',

  mixins: [tableHeight(161)],

  filters: {
    dateFormat: v => format(new Date(v), 'yyyy-MM-dd HH:mm'),
  },

  props: {
    events: Array,
  },

  methods: {
    order(arr) {
      return orderBy(arr, ['created'], ['desc'])
    },
  },
}
</script>
